import { generatePath, useParams } from "react-router";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";
import type { Kpi } from "@acto/taskpane/core/domain";
import { useProductDrill } from "@acto/taskpane/field-sales-2/pages/analysis/ProductDrillContext";
import { useDirectionalNavigate } from "@acto/taskpane/field-sales-2/utils/viewTransitions";
import { AnalysisBottomNav } from "./AnalysisBottomNav";

interface OrderDetailsBottomNavProps {
  selectedKpi: Kpi;
  onKpiChange: (kpi: Kpi) => void;
}

export function OrderDetailsBottomNav({ selectedKpi, onKpiChange }: OrderDetailsBottomNavProps) {
  const { id } = useParams<{ id: string }>();
  const navigate = useDirectionalNavigate();
  const { drillTo } = useProductDrill();

  const openAnalysisTab = (kpi: Kpi) => {
    onKpiChange(kpi);
    drillTo(0);
    if (id) navigate(generatePath(ActoRoutes.CUSTOMER_ANALYSIS, { id }), { direction: "pop" });
  };

  return <AnalysisBottomNav selectedKpi={selectedKpi} onKpiChange={openAnalysisTab} />;
}
